import { useState } from "react";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { PLATFORMS, waLink } from "../data";
import { useLang } from "../i18n";

const PlatformCard = ({ p, i, tag }) => {
  const [err, setErr] = useState(false);
  return (
    <Reveal delay={i * 0.07}>
      <a
        href={p.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`platform-link-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`}
        className="group flex h-full flex-col justify-between rounded-2xl border border-cream/15 bg-cream/[0.06] p-6 backdrop-blur-sm transition-colors duration-300 hover:border-saffron/60 hover:bg-cream/10"
      >
        <div className="flex h-10 items-center">
          {err ? (
            <span className="font-display text-xl font-bold" style={{ color: p.brand }}>
              {p.name}
            </span>
          ) : (
            <img
              src={p.logo}
              alt={`${p.name} logo`}
              loading="lazy"
              onError={() => setErr(true)}
              className="max-h-9 w-auto max-w-[150px] object-contain"
            />
          )}
        </div>
        <div className="mt-8 flex items-end justify-between">
          <div>
            <p className="font-display text-lg font-bold text-cream">{p.name}</p>
            <p className="mt-0.5 text-xs text-cream/55">{tag}</p>
          </div>
          <span className="rounded-full border border-cream/20 p-2 text-cream/70 transition-colors duration-300 group-hover:border-saffron group-hover:text-saffron">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </a>
    </Reveal>
  );
};

export const Platforms = () => {
  const { s } = useLang();
  return (
  <section id="platforms" className="relative bg-peacock py-24 sm:py-32 grain" data-testid="platforms-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold" data-testid="platforms-overline">
          {s.platforms.overline}
        </p>
        <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-cream tracking-tight max-w-2xl" data-testid="platforms-heading">
            {s.platforms.heading}
          </h2>
          <a
            href={waLink("Namaste! I found Shri Jamuna Dham online. Please share your best direct tariff.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="platforms-direct-whatsapp-link"
            className="inline-flex items-center gap-2 rounded-full bg-saffron px-6 py-3 text-sm font-semibold text-night transition-colors duration-300 hover:bg-gold"
          >
            <MessageCircle size={16} /> {s.platforms.direct}
          </a>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5" data-testid="platforms-grid">
        {PLATFORMS.map((p, i) => (
          <PlatformCard key={p.name} p={p} i={i} tag={s.platforms.tags[i]} />
        ))}
      </div>
    </div>
  </section>
  );
};
